export default "__VITE_ASSET__CAnxrit3__"